<template lang="pug">
section.d-flex.--col.LndIntro
  Svgi.__logo(name="ohm-logo")
  span.__desc(v-html="L[0]")
</template>
<script>
import content from 'content';

export default {
  name: 'LndIntro',
  inject: ['mq'],

  static: () => ({
    L: content.intro,
  }),
};

</script>
<style>
.LndIntro {
  z-index: 1;

  line-height: 32px;

  .__logo {
    width: 100%;
    max-width: 170px;
    height: 50px;
  }

  .__desc {
    margin-bottom: 32px;
  }
}

@media (min-width: 740px) {
  .LndIntro {
    /*--gap-v: calc(32 / var(--vw-scale)) calc(60 / var(--vw-scale));*/
    /*margin-bottom: calc(48 / var(--vw-scale));*/

    .__logo {
      width: 100%;
      max-width: 280px;
      height: 77px;

      margin-bottom: 36px;
    }

    .__desc {
      max-width: 400px;

      font-weight: 400;
      font-size: 25px;
      line-height: 40px;
    }

    > * { order: unset !important; }
  }
}

@media (max-width: 739px) {
  .LndIntro {
    display: flex !important;
    flex-direction: column;
    align-self: flex-start;
    margin-top: 10vh;

    span {
      display: block;
      margin-bottom: 30px;
      /*margin-left: 100px;*/
    }

    .__logo {
      margin-top: 60px;
      margin-bottom: 30px;
    }

    .__desc {
      font-size: 20px;
      line-height: 36px;
    }
    /*.__sm-bg {*/
    & {
      display: block;
      /*background-color: var(--bg2);*/

      width: calc(100% + var(--page-pad) * 2);
      margin: 0 calc(-1 * var(--page-pad));
      padding: var(--page-pad);
    }

    /*margin-top: calc(-1 * var(--page-pad));*/
  }
}
</style>
